exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".great-diving.no-padding{padding-bottom:0}.great-diving.border-bottom{margin-bottom:32px;border-bottom:1px solid #dde3e6}.great-diving.border-top{margin-top:0;padding-top:64px;border-top:1px solid #dde3e6}@media(max-width:1024px){.great-diving.border-bottom{margin-bottom:16px}.great-diving.border-top{padding-top:32px}}", ""]);

